// Reads i18n strings + bootstrap data baked into #crew-magic-root by
// app/helpers/dashboards_helper.rb. The hook is a thin wrapper around
// useMemo so consumers can call it freely.

import { useMemo } from "react"

let cachedTranslations = null
let cachedBootstrap = null

export function readDashboardData(rootEl) {
  cachedTranslations = JSON.parse(rootEl.dataset.translations || "{}")
  cachedBootstrap = JSON.parse(rootEl.dataset.bootstrap || "{}")
}

export function useTranslations() {
  return useMemo(() => {
    return (key, vars = {}) => {
      const raw = (cachedTranslations || {})[key] || key
      return Object.entries(vars).reduce(
        (acc, [k, v]) => acc.replaceAll(`%{${k}}`, v),
        raw,
      )
    }
  }, [])
}

export function useBootstrap() {
  return cachedBootstrap || {}
}
